let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("UXtYY")).then(() => parcelRequire('5R9cq'));